export function calculateAsPathName({ pathName, nameLabel, page }) {
  if (Number(page) === 1) {
    return pathName
  }

  return `${pathName}/${nameLabel}-${page}`
}
